var map = {
	"./common/app.js": "./assets/common/app.js",
	"./common/config.js": "./assets/common/config.js",
	"./default/main.js": "./assets/default/main.js",
	"./default/page/index.js": "./assets/default/page/index.js",
	"./default/service/sampleService.js": "./assets/default/service/sampleService.js"
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "./assets eager recursive ^\\.\\/.*\\.js$ include: \\.js$ exclude: (webpack)";
module.exports = webpackAsyncContext;